import { useContext } from "react";
import { LoaderContext } from "../context";

function useLoader() {
  const { isLoading, toggleLoader } = useContext(LoaderContext);
  return { isLoading, toggleLoader };
}

export default useLoader;
